<template>
    <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="zc-sider">
        <Menu theme="light" width="auto" :open-names="[$store.state.open_names]" :active-name="$store.state.active_names" accordion>
            <span v-for="(item,index) in menu" :key="index">
                <MenuItem :name="item.Id" v-if="!item.Childrens" @click.native="GoLink(item.Url)">
                        <Icon :type="item.Icon"/>
                        {{item.Title}}
                </MenuItem>
                <Submenu :name="item.Id" v-else>
                    <template slot="title">
                        <Icon :type="item.Icon"/>
                       {{item.Title}}
                    </template>
                    <MenuItem :name="String(item.Id)+'-'+String(items.Id)" v-for="(items,indexs) in item.Childrens" :key="indexs" @click.native="GoLink(items.Url)"><Icon :type="!!items.Icon ? items.Icon : 'ios-arrow-forward'"/> {{items.Title}}</MenuItem>
                </Submenu>
            </span>
        </Menu>
    </Sider>
</template>

<script>
export default {
    name: 'Side',
    components: {},
    props:{
        menu_id : { default : "1" }
    },
    data () {
        return {
            theme: 'dark',
            menu:[],
        }
    },
    created(){
        this.GetMenu();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    methods: {
        GetMenu(){
            let that = this;
            that.menu =  JSON.parse(decodeURIComponent(this.$store.state.auth));
            let route_info = this.$route;
            let auth =  JSON.parse(decodeURIComponent(this.$store.state.auth));
            auth.forEach((item,index) => {
                if(item.Id == route_info.meta.id){
                    this.$store.commit('SET_OPEN_NAMES' , item.Id);
                    this.$store.commit('SET_ACTIVE_NAMES' ,item.Id);
                    this.$store.commit('SET_PARENT_ROUTER_NAME' ,item.Title);
                }else if(!!item.Childrens){
                    let children = item.Childrens;
                    children.forEach((items,indexs) => {
                        if(items.Id == route_info.meta.id){
                            this.$store.commit('SET_OPEN_NAMES' , item.Id);
                            this.$store.commit('SET_ACTIVE_NAMES' ,String(item.Id)+'-'+String(items.Id));
                            this.$store.commit('SET_PARENT_ROUTER_NAME' ,item.Title);
                        }
                    })
                }
            })
        },

        GoLink(url) {
            let that = this;
            that.$router.push({
                path : url,
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>



// WEBPACK FOOTER //
// src/components/public/Side.vue